export const GENERAL = "general";
export const GENERAL_REGISTRATION_NUMBER = "registrationNumber";
export const GENERAL_VEHICLE_TYPE_ID = "vehicleTypeId";
export const GENERAL_VEHICLE_TYPE_NAME = "vehicleTypeName";
export const GENERAL_LIFECYCLE_STATUS = "lifecycleStatus";

export const DETAILS = "details";
export const DETAILS_CATEGORY = "category";
export const DETAILS_SUB_CATEGORY = "subCategory";
export const DETAILS_MANUFACTURER = "manufacturer";
export const DETAILS_MODEL = "model";
export const DETAILS_MAX_PAYLOAD = "maxPayload";
export const DETAILS_MAX_VOLUME = "maxVolume";
export const DETAILS_INTERIOR_LENGTH = "interiorLength";
export const DETAILS_INTERIOR_WIDTH = "interiorWidth";
export const DETAILS_INTERIOR_HEIGHT = "interiorHeight";

export const DRIVER_ASSIGNMENTS = "driverAssignments";
export const DRIVER_ASSIGNMENTS_AUTHORIZED_USERS = "authorizedUsers";
export const DRIVER_ASSIGNMENTS_ASSIGNMENTS = "assignments";
export const DRIVER_ASSIGNMENTS_ASSIGNMENT_MODAL = "assignmentModal";
export const DRIVER_ASSIGNMENTS_ASSIGNMENT_MODAL_DRIVER_ID = "driverId";
export const DRIVER_ASSIGNMENTS_ASSIGNMENT_MODAL_START_DATE = "startDate";
export const DRIVER_ASSIGNMENTS_ASSIGNMENT_MODAL_START_TIME = "startTime";
export const DRIVER_ASSIGNMENTS_ASSIGNMENT_MODAL_END_DATE = "endDate";
export const DRIVER_ASSIGNMENTS_ASSIGNMENT_MODAL_END_TIME = "endTime";